import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import UpdatePrompt from './UpdatePrompt.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
    <UpdatePrompt />
  </React.StrictMode>
)
